function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "42",
  height: "57",
  viewBox: "0 0 42 57",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.556.605C21.49.105 21.253 0 21 0c-.253 0-.49.105-.556.605-.512 3.905-3.46 9.596-8.2 14.008C9.15 17.489 0 24.685 0 36.16 0 47.746 9.821 57 20.999 57 32.177 57 42 47.746 42 36.16c0-11.475-9.151-18.67-12.243-21.547C25.017 10.2 22.067 4.51 21.556.605z",
  fill: "currentColor",
  fillRule: "evenodd"
})));